import { __awaiter, __generator } from "tslib";
/**
 * Chain adapter
 * Usefull to use multiple adapters
 */
var Chain = /** @class */ (function () {
    function Chain(adapters) {
        this.adapters = adapters;
    }
    Chain.prototype.record = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.all(this.adapters.map(function (adapter) { return adapter.record(request); }))];
            });
        });
    };
    Chain.prototype.getName = function () {
        return __awaiter(this, void 0, void 0, function () {
            var names;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.adapters.map(function (adapter) { return adapter.getName(); }))];
                    case 1:
                        names = _a.sent();
                        return [2 /*return*/, "Chain which contains: " + names.join(", ")];
                }
            });
        });
    };
    return Chain;
}());
export default Chain;
//# sourceMappingURL=Chain.js.map